import { settingsApi } from "@src/service/settings";

import { put, call, takeLatest, select } from "redux-saga/effects";
import { setGlobalLoader, setSnackbar } from "../generals/actionCreators";
import { LoadingStatus } from "../generals/types";
import {
  EDIT_RESTAURANT_SEND_TO_POS_SAGA,
  FETCH_PICKUP_TIME,
  FETCH_PICKUP_TIME_SUCCESS,
  FETCH_RESTAURANTS_STATUSSES,
  FETCH_RESTAURANTS_STATUSSES_SUCCESS,
  GET_RESTAUANT_SEND_TO_POS_SAGA,
  GET_RESTAUANT_SEND_TO_POS_SUCCESS,
  UPDATE_PICKUP_TIME,
  UPDATE_RESTAURANT_STATUS,
  FETCH_BUSY_MODES,
  FETCH_BUSY_MODES_SUCCESS,
  SET_BUSY_MODE,
  DELETE_BUSY_MODE,
  EDIT_RETRY_COUNT,
  FETCH_RETRY_COUNT,
  FETCH_RETRY_COUNT_SUCCESS,
  SET_STORE_AUTO_OPEN,
} from "@src/store/settings/types/actionTypes";
import { fetchRestaurantsStatusses, fetchTime } from "./actionCreators";
import { getRequestError } from "@src/utils/getRequestError";
import { Aggregator } from "@src/pages/LocationPage/generator";
import { delivery } from "@src/pages/OrderPage/generator";

export function* fetchPickupTimeRequest(action: any): any {
  try {
    yield put(setGlobalLoader(LoadingStatus.LOADING));
    const rest_id = action.payload;
    const { data } = yield call(settingsApi.getPickupTime, rest_id);
    yield put({
      type: FETCH_PICKUP_TIME_SUCCESS,
      payload: { data: data.time },
    });
    yield put(setGlobalLoader(LoadingStatus.SUCCESS));
  } catch (e: any) {
    yield put(setGlobalLoader(LoadingStatus.ERROR));
  }
}

export function* updatePickupTimeRequest(action: any): any {
  try {
    yield put(setGlobalLoader(LoadingStatus.LOADING));

    yield call(
      settingsApi.updatePickupTime,
      action.payload.resti_id,
      action.payload.time
    );

    yield put(fetchTime(action.payload.resti_id));

    yield put(setGlobalLoader(LoadingStatus.SUCCESS));
  } catch (e: any) {
    yield put(setGlobalLoader(LoadingStatus.ERROR));
  }
}

export function* fetchRestaurantsStatussesRequest(action: any): any {
  try {
    yield put(setGlobalLoader(LoadingStatus.LOADING));
    const { resti_id, page, aggregator } = action.payload;
    const { data } = yield call(
      settingsApi.getRestaurants,
      resti_id,
      page,
      aggregator,
      10
    );

    if (data?.location_list)
      yield put({
        type: FETCH_RESTAURANTS_STATUSSES_SUCCESS,
        payload: {
          data: data?.location_list,
          page_count: data?.pagination.page_count,
        },
      });
    yield put(setGlobalLoader(LoadingStatus.SUCCESS));
  } catch (e: any) {
    yield put(setGlobalLoader(LoadingStatus.ERROR));
  }
}

export function* updateRestaurantStatusRequest(action: any): any {
  try {
    yield put(setGlobalLoader(LoadingStatus.LOADING));

    const { data } = yield call(
      settingsApi.switchRestaurants,
      action.payload.data
    );
    const rest_group_id = localStorage.getItem("currRestGroupId");
    yield put(
      fetchRestaurantsStatusses(
        String(rest_group_id),
        action.payload.page,
        action.payload.aggregator
      )
    );
    if (data?.[0]?.err_message) {
      yield put(
        setSnackbar({
          status: "error",
          message: data?.[0]?.err_message,
          visible: true,
        })
      );
    } else {
      yield put(
        setSnackbar({ status: "success", message: "Success", visible: true })
      );
    }

    yield put(setGlobalLoader(LoadingStatus.SUCCESS));
  } catch (e: any) {
    yield put(
      setSnackbar({
        status: "error",
        message: getRequestError(e),
        visible: true,
      })
    );
    yield put(setGlobalLoader(LoadingStatus.ERROR));
  }
}

export function* editRestaurantSendToPosRequest(action: any) {
  try {
    yield call(settingsApi.editRestaurantSendToPos, action.payload);
    yield put(
      setSnackbar({ status: "success", message: "Success", visible: true })
    );
  } catch (e) {
    yield put(
      setSnackbar({
        status: "error",
        message: getRequestError(e),
        visible: true,
      })
    );
  }
}

// SETTINGS POS
export function* fetchRestaurantSendToPosRequest(action: any) {
  try {
    yield put(setGlobalLoader(LoadingStatus.LOADING));

    const { restaurant_group_id, aggregator } = action.payload;

    const { data } = yield call(
      settingsApi.getRestaurantSendToPos,
      restaurant_group_id,
      aggregator
    );
    yield put({
      type: GET_RESTAUANT_SEND_TO_POS_SUCCESS,
      payload: data?.restaurants,
    });

    yield put(setGlobalLoader(LoadingStatus.SUCCESS));
  } catch (e) {
    yield put(setGlobalLoader(LoadingStatus.ERROR));
    yield put(
      setSnackbar({
        status: "error",
        message: getRequestError(e),
        visible: true,
      })
    );
  }
}

export function* fetchBusyModesRequest(action: any) {
  try {
    yield put(setGlobalLoader(LoadingStatus.LOADING));
    const { resti_id } = action.payload;
    const { data } = yield call(settingsApi.getBusyModes, resti_id);
    yield put({
      type: FETCH_BUSY_MODES_SUCCESS,
      payload: { data: data },
    });
    yield put(setGlobalLoader(LoadingStatus.SUCCESS));
  } catch (e) {
    yield put(setGlobalLoader(LoadingStatus.ERROR));
    yield put(
      setSnackbar({
        status: "error",
        message: getRequestError(e),
        visible: true,
      })
    );
  }
}

export function* setBusyModeRequest(action: any) {
  try {
    yield put(setGlobalLoader(LoadingStatus.LOADING));
    const { rest_id, adjusted_minutes } = action.payload;
    yield call(settingsApi.setBusyMode, rest_id, adjusted_minutes);
    yield put(setGlobalLoader(LoadingStatus.SUCCESS));
  } catch (e) {
    yield put(setGlobalLoader(LoadingStatus.ERROR));
    yield put(
      setSnackbar({
        status: "error",
        message: getRequestError(e),
        visible: true,
      })
    );
  }
}

export function* deleteBusyModeRequest(action: any) {
  try {
    yield put(setGlobalLoader(LoadingStatus.LOADING));
    const { rest_id } = action.payload;
    yield call(settingsApi.deleteBusyMode, rest_id);
    yield put(setGlobalLoader(LoadingStatus.SUCCESS));
  } catch (e) {
    yield put(setGlobalLoader(LoadingStatus.ERROR));
    yield put(
      setSnackbar({
        status: "error",
        message: getRequestError(e),
        visible: true,
      })
    );
  }
}

export function* editRetryCountRequest(action: any) {
  try {
    yield put(setGlobalLoader(LoadingStatus.LOADING));
    const { resti_id, count } = action.payload;
    yield call(settingsApi.editRetryCount, resti_id, count);
    yield call(getRetryCount, { payload: { resti_id } });
    yield put(setGlobalLoader(LoadingStatus.SUCCESS));
    yield put(
      setSnackbar({ status: "success", message: "Success", visible: true })
    );
  } catch (e) {
    yield put(setGlobalLoader(LoadingStatus.ERROR));
    yield put(
      setSnackbar({
        status: "error",
        message: getRequestError(e),
        visible: true,
      })
    );
  }
}

export function* getRetryCount(action: any) {
  try {
    yield put(setGlobalLoader(LoadingStatus.LOADING));
    const { resti_id } = action.payload;
    const { data } = yield call(settingsApi.getRetryCount, resti_id);
    yield put({
      type: FETCH_RETRY_COUNT_SUCCESS,
      payload: { data: data.retry_count },
    });
    yield put(setGlobalLoader(LoadingStatus.SUCCESS));
  } catch (e) {
    yield put(setGlobalLoader(LoadingStatus.ERROR));
    yield put(
      setSnackbar({
        status: "error",
        message: getRequestError(e),
        visible: true,
      })
    );
  }
}

export function* setStoreAutoOpenRequest(action: any) {
  try {
    yield put(setGlobalLoader(LoadingStatus.LOADING));
    const { rest_id, is_open, delivery_type } = action.payload;
    yield call(settingsApi.setStoreAutoOpen, rest_id, is_open, delivery_type);
    yield put(setGlobalLoader(LoadingStatus.SUCCESS));
  } catch (e) {
    yield put(setGlobalLoader(LoadingStatus.ERROR));
    yield put(
      setSnackbar({
        status: "error",
        message: getRequestError(e),
        visible: true,
      })
    );
  }
}

export function* settingsSaga() {
  yield takeLatest(FETCH_PICKUP_TIME, fetchPickupTimeRequest);
  yield takeLatest(UPDATE_PICKUP_TIME, updatePickupTimeRequest);
  yield takeLatest(
    FETCH_RESTAURANTS_STATUSSES,
    fetchRestaurantsStatussesRequest
  );
  yield takeLatest(UPDATE_RESTAURANT_STATUS, updateRestaurantStatusRequest);
  yield takeLatest(
    GET_RESTAUANT_SEND_TO_POS_SAGA,
    fetchRestaurantSendToPosRequest
  );
  yield takeLatest(
    EDIT_RESTAURANT_SEND_TO_POS_SAGA,
    editRestaurantSendToPosRequest
  );
  yield takeLatest(FETCH_BUSY_MODES, fetchBusyModesRequest);
  yield takeLatest(DELETE_BUSY_MODE, deleteBusyModeRequest);
  yield takeLatest(SET_BUSY_MODE, setBusyModeRequest);
  yield takeLatest(EDIT_RETRY_COUNT, editRetryCountRequest);
  yield takeLatest(FETCH_RETRY_COUNT, getRetryCount);
  yield takeLatest(SET_STORE_AUTO_OPEN, setStoreAutoOpenRequest);
}
